import { ChannelSimple as Base } from '@whispli/client/tenant/openapi/client/model/ChannelSimple'

export class ChannelSimple extends Base {
  get channelType() {
    return this?.channelableType
  }
}
